import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const medicalExamTypeLocaleModule: LocaleModule = {
  name: "medicalExamType",
  messages: { en: en, it: it },
};
